import { Component, HostListener, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { DialogService } from '@ngneat/dialog';

import { CredentialsService } from '@auth';
import { ProfilePictureUpdateFormComponent } from '@shared/components/forms';
import { NotificationsComposition } from '@shared/compositions';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  menuHidden = true;
  searchInput = '';
  showProfileImage = true;
  fetchFromLocal = false;
  selectedLanguage = 'de';
  private readonly _credentialsService = inject(CredentialsService);
  private readonly _router = inject(Router);
  private readonly _dialogService = inject(DialogService);
  private readonly _notificationsComposition = inject(NotificationsComposition);

  get fullName(): string | null {
    const credentials = this._credentialsService.credentials;
    return credentials ? `${credentials.firstName} ${credentials.lastName}` : null;
  }

  get username(): string | null {
    const credentials = this._credentialsService.credentials;
    return credentials ? credentials.username : null;
  }

  get email(): string | null {
    const credentials = this._credentialsService.credentials;
    return credentials ? credentials.email : null;
  }

  get clubName(): string | null {
    const credentials = this._credentialsService.credentials;
    if (!credentials || !credentials?.club) window.location.href = '/logout';
    return credentials ? credentials.club.name : null;
  }

  get logoUrl(): string | null {
    const credentials = this._credentialsService.credentials;
    if (!credentials || !credentials?.club) window.location.href = '/logout';
    return credentials ? credentials?.club?.logoUrl : null;
  }

  get userRole(): string | null {
    const credentials = this._credentialsService.credentials;
    return credentials ? credentials.roles[0] : null;
  }

  get memberId(): number {
    const credentials = this._credentialsService.credentials;
    return credentials ? credentials.memberId : null;
  }

  get hasNotifications(): boolean {
    return this._notificationsComposition.hasNotifications;
  }

  ngOnInit() {
    this.searchInput = this._router.url.includes('search') ? this._router.url.split('/')[2] : this.searchInput;
  }

  @HostListener('window:resize')
  showLabel(): boolean {
    return window.innerWidth > 1110;
  }

  search(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;
    if (event.key === 'Enter' && value) {
      this._router.navigate([`/search/${value}`]);
    }
  }

  openProfileImageUpdateDialog(event: Event) {
    this._dialogService
      .open(ProfilePictureUpdateFormComponent, {
        size: 'md',
        closeButton: false,
        windowClass: 'dialog-overflow-y-auto',
      })
      .afterClosed$.pipe(untilDestroyed(this))
      .subscribe({
        next: (res) => {
          if (res) {
            const element = (event.currentTarget as HTMLElement) || (event.target as HTMLElement);

            if (element) {
              if (!element.classList.contains('background-loading-small')) {
                element.classList.add('background-loading-small');
              }
            }
            this.showProfileImage = false;
            this.fetchFromLocal = true;
            setTimeout(() => {
              this.showProfileImage = true;
              // window.location.reload();
            }, 10000);
          }
        },
      });
  }

  protected _reloadCurrentRoute(path?: string) {
    const currentUrl = path || this._router.url;
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([currentUrl]);
    });
  }
}
